import React, { useState } from 'react';


import {
    deleteUser,
    getUserInfo,
    insertUser,
    getUserInfoByUser,
    updateUserInfo,
    updatePassword,
    changeUserSignature,
    uploadSignaturefile,
    uploadSignatureb64,
    getSignature,
    setLocations,
    updatePasswordByUser,
    keepLog,
    getEmployeeLookupApi

} from '../utils/api-action';


const importLocations = async (param) => {
    var result = await setLocations(param)
    return result;

}

const getUsers = async (param) => {
    var result = await getUserInfo(param)
    return result;

}

const getUsersDetail = async (param) => {
    var result = await getUserInfoByUser(param)
    return result;

}



const removeUser = async (param) => {
    var result = await deleteUser(param)
    return result;

}

const newUser = async (param) => {
    var result = await insertUser(param)
    return result;

}


const update = async (param) => {
    var result = await updateUserInfo(param)
    return result;

}

const editPassword = async (param) => {
    var result = await updatePassword(param)
    return result;

}

const changeSignature = async (param) => {
    var result = await changeUserSignature(param)
    return result;
}

const getUserSignature = async (param) => {
    var result = await getSignature(param)
    return result;
}

const uploadSignatureBase64 = async (param) => {
    var result = await uploadSignatureb64(param)
    return result;
}


const uploadSignatureFile = async (param) => {
    var result = await uploadSignaturefile(param)
    return result;
}

const editPasswordByUserLogin = async (param) => {
    var result = await updatePasswordByUser(param)
    return result;

}

const saveLog = async (param) => {
    var result = await keepLog(param)
    return result;

}


const getEmployeeLookup = async (param) => {
    var result = await getEmployeeLookupApi(param)
    return result;

}



export {
    getUsers,
    removeUser,
    newUser,
    update,
    getUsersDetail,
    editPassword,
    changeSignature,
    uploadSignatureBase64,
    uploadSignatureFile,
    getUserSignature,
    importLocations,
    editPasswordByUserLogin,
    saveLog,
    getEmployeeLookup
};
